/**
 * Wall&CeilingBoard cross-section profile.
 *
 * Extracted from `wcb.svg` (the product's side/extrusion profile) via
 * `scripts/extract-svg-profile.js`. The SVG is 72 units/inch; its long axis is
 * the panel's 17.25" coverage height (16" exposed + ~1.25" tongue/flange) and
 * its short axis is the 0.5" depth.
 *
 * Stored in inches in the JSON; converted to feet here so the rest of the
 * visualizer's room math stays in feet.
 */

import type { CrossSectionProfile } from './profileRegistry';
import data from './wcbProfilePoints.json';

const IN_TO_FT = 1 / 12;

const points = data.points.map(
  ([u, v]) => [u * IN_TO_FT, v * IN_TO_FT] as readonly [number, number],
);

export const WCB_PROFILE: CrossSectionProfile = {
  id: 'WCB',
  points,
  depthSize: data.uSize * IN_TO_FT,
  verticalSize: data.vSize * IN_TO_FT,
};
